module.exports = __webpack_public_path__ + "static/media/pshbtn.6eb32811.ico";